import { DataTableHeader as Header } from "../types";

export interface DataTableResizeHandlerProps<T extends object> extends React.ComponentProps<"div"> {
  header: Header<T, unknown>;
}

export const DataTableResizeHandler = <T extends object>({ header }: DataTableResizeHandlerProps<T>) => {
  const resizeHandler = header.getResizeHandler();
  const isFirstColumn = header.id === "offloadIcon";
  const isResizable = header.column.getCanResize();

  if (!isResizable) return null;

  return (
    <div
      onMouseDown={resizeHandler}
      onTouchStart={resizeHandler}
      className="h-full w-[2px] right-0 absolute top-0 cursor-col-resize select-none touch-none hover:opacity-100 bg-neutral-mid-gray"
    >
      {!isFirstColumn && (
        <div className="absolute left-1/2 h-full w-[2px] -translate-x-1/2 bg-neutral-mid-gray" />
      )}
    </div>
  );
};